import { render, staticRenderFns } from "./LiquorPage.vue?vue&type=template&id=5b6c8cc8&scoped=true"
import script from "./LiquorPage.vue?vue&type=script&lang=js"
export * from "./LiquorPage.vue?vue&type=script&lang=js"
import style0 from "./LiquorPage.vue?vue&type=style&index=0&id=5b6c8cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6c8cc8",
  null
  
)

export default component.exports